export const trackerLogButtonFontSize = '0.9rem';
export const trackerToolbarNeutralTextColor = '#111111';
export const trackerToolbarNeutralOutlineColor = '#9CA3AF';
export const trackerToolbarNeutralHoverFill = 'rgba(15, 23, 42, 0.04)';

export const trackerToolbarButtonTypographySx = {
  fontFamily: '"Open Sans", Arial, sans-serif',
  fontSize: trackerLogButtonFontSize,
  fontWeight: 400,
  textTransform: 'none',
} as const;

export const trackerFilterTypographySx = {
  fontFamily: trackerToolbarButtonTypographySx.fontFamily,
  fontSize: trackerLogButtonFontSize,
} as const;

export const trackerFilterFieldLabelTypographySx = {
  ...trackerFilterTypographySx,
  fontSize: '0.84rem',
} as const;

export const trackerFilterChipTypographySx = {
  fontFamily: '"Inter", "Open Sans", Arial, sans-serif',
  fontSize: '10px',
  fontWeight: 500,
  fontStyle: 'normal',
  lineHeight: 1.25,
  letterSpacing: '0.03em',
  color: trackerToolbarNeutralTextColor,
  minHeight: 24,
  height: 'auto',
  '&.MuiChip-sizeSmall': {
    minHeight: 24,
    height: 'auto',
  },
  '& .MuiChip-label': {
    fontFamily: '"Inter", "Open Sans", Arial, sans-serif',
    fontSize: '10px',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: '0.03em',
    color: trackerToolbarNeutralTextColor,
    display: 'block',
    paddingTop: '2px',
    paddingBottom: '2px',
  },
} as const;

export const trackerFilterStatusChipTypographySx = {
  ...trackerFilterChipTypographySx,
  fontSize: '12px',
  minHeight: 28,
  '&.MuiChip-sizeSmall': {
    minHeight: 28,
    height: 'auto',
  },
  '& .MuiChip-label': {
    ...trackerFilterChipTypographySx['& .MuiChip-label'],
    fontSize: '12px',
    paddingTop: '3px',
    paddingBottom: '3px',
  },
} as const;

export const trackerPopupPaperSx = {
  borderRadius: '16px',
  border: '1px solid #E5E7EB',
  boxShadow: '0 10px 30px rgba(15, 23, 42, 0.14)',
  backgroundColor: '#FFFFFF',
} as const;

export const trackerFilterPopoverPaperSx = {
  ...trackerPopupPaperSx,
  minWidth: '700px',
  maxHeight: '75vh',
  overflowY: 'auto',
} as const;

export const trackerFilterPopoverContainerSx = {
  width: '700px',
  padding: '27px 20px',
} as const;

export const trackerPopupActionButtonSx = {
  ...trackerToolbarButtonTypographySx,
  height: '32px',
  borderRadius: '8px',
  px: 1.5,
} as const;

export const trackerPopupTitleTypographySx = {
  fontFamily: trackerToolbarButtonTypographySx.fontFamily,
  fontSize: '24px',
  fontWeight: 600,
  letterSpacing: '-0.05em',
  lineHeight: 1.2,
  color: '#111111',
} as const;

export const trackerPopupBodyTypographySx = {
  fontFamily: trackerToolbarButtonTypographySx.fontFamily,
  fontSize: trackerLogButtonFontSize,
  fontWeight: 500,
  lineHeight: 1.5,
  color: trackerToolbarNeutralTextColor,
} as const;
